import { createAsyncThunk } from '@reduxjs/toolkit';
//import httpService from '@/rtk-apis/axios-config/http-service';
import { GET_PATIENT_DETAIL_API_URL } from '@custom/constant';
import { _appointmentUrls, _patientUrls } from '@custom/Utils/constants/apiUrls';

const latestModality = createAsyncThunk('latestModality', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = _patientUrls.latestModality;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
        // JSON.stringify({
        //   hospitalId: hospitalId,
        //   uhid: uhid,
        // }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch patient details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default latestModality;
